import React from "react";
import { isEmpty, startCase } from "lodash";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";
import TableHeaderCell from "components/reusable/TableHeaderCell";

const Table = ({ employeeList, page, sort, setSort, handleView }) => {
  const { t } = useTranslation();

  const handleSort = (sortByValue, sortTypeValue) => {
    const newSortType = sort.sortType === "asc" ? "desc" : "asc";
    setSort({
      sortBy: sortByValue,
      sortType: sortByValue === sort.sortBy ? newSortType : sortTypeValue,
    });
  };

  return (
    <div className="p-3">
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-6">
                #
              </th>
              <TableHeaderCell text={t("EMPLOYEE_ID")} />
              <TableHeaderCell text={t("EMPLOYEE_NAME")} />
              <TableHeaderCell text={t("DEPARTMENT")} />
              <TableHeaderCell text={t("JOB_TITLE")} />

              <th scope="col" className="py-3 px-6 cursor-pointer" onClick={() => handleSort("createdAt", "asc")}>
                <div className="flex justify-start">
                  <span>{t("CREATED_DATE")}</span>
                  <span>
                    {sort.sortBy === "createdAt" && sort.sortType === "asc" && <BsArrowUpShort className="w-4 h-4" />}
                    {sort.sortBy === "createdAt" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180" />}
                  </span>
                </div>
              </th>

              <th scope="col" className="py-3 px-6 cursor-pointer" onClick={() => handleSort("acceptedRejectedAt", "asc")}>
                <div className="flex justify-start">
                  <span>{t("ACCEPT_AND_REJECT_DATE")}</span>
                  <span>
                    {sort.sortBy === "acceptedRejectedAt" && sort.sortType === "asc" && <BsArrowUpShort className="w-4 h-4" />}
                    {sort.sortBy === "acceptedRejectedAt" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180" />}
                  </span>
                </div>
              </th>
              <th scope="col" className="py-3 px-6 cursor-pointer" onClick={() => handleSort("fromDate", "asc")}>
                <div className="flex justify-start">
                  <span>{t("FROM_DATE")}</span>
                  <span>
                    {sort.sortBy === "fromDate" && sort.sortType === "asc" && <BsArrowUpShort className="w-4 h-4" />}
                    {sort.sortBy === "fromDate" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180" />}
                  </span>
                </div>
              </th>
              <th scope="col" className="py-3 px-6 cursor-pointer" onClick={() => handleSort("toDate", "asc")}>
                <div className="flex justify-start">
                  <span>{t("TO_DATE")}</span>
                  <span>
                    {sort.sortBy === "toDate" && sort.sortType === "asc" && <BsArrowUpShort className="w-4 h-4" />}
                    {sort.sortBy === "toDate" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180" />}
                  </span>
                </div>
              </th>

              <TableHeaderCell text={t("TYPE")} />
              <TableHeaderCell text={t("TOTAL_DAYS")} />
              <TableHeaderCell text={t("OFFERS_DESCRIPTION")} />
              <th scope="col" className="px-6 text-center py-3">
                {t("O_STATUS")}
              </th>
            </tr>
          </thead>
          <tbody>
            {employeeList &&
              employeeList?.map((item, i) => {
                return (
                  <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                    <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
                      {i + 1 + 10 * (page - 1)}
                    </th>
                    <td className="py-4 px-6 border-r">{item?.Employee?.employeeId} </td>
                    <td className="border-r py-4 px-6 ">{startCase(item?.Employee?.name)}</td>
                    <td className="text-left py-4 px-6 border-r ">{startCase(item?.Department?.name)}</td>
                    <td className="py-4 border-r px-6 text-left">{startCase(item?.Job?.name)}</td>
                    <td className="px-6 border-r text-left py-4 ">{dayjs(item?.createdAt).format("MM-DD-YYYY hh:mm A")}</td>
                    <td className="py-4 px-6 border-r text-left">{dayjs(item?.acceptedRejectedAt).format("MM-DD-YYYY hh:mm A")}</td>
                    <td className="py-4 px-6 border-r text-left">{dayjs(item?.fromDate).format("MM-DD-YYYY hh:mm A")}</td>
                    <td className="py-4 px-6 border-r text-left">{dayjs(item?.toDate).format("MM-DD-YYYY hh:mm A")}</td>
                    <td className="py-4 px-6 border-r text-left">{startCase(item?.leaveType)} </td>
                    <td className="py-4 px-6 border-r text-left">{item?.noOfDays} </td>
                    <td className="py-4 px-6 border-r text-left">
                      {item?.reason.split(" ").slice(0, 1).join(" ")}.... &nbsp;{" "}
                      <span title="View more" className="cursor-pointer text-green-600 " onClick={() => handleView(item)}>
                        {"view more"}
                      </span>
                    </td>
                    <td className="py-4 px-6 border-r text-center">{startCase(item?.status)} </td>
                  </tr>
                );
              })}
            {isEmpty(employeeList) ? (
              <tr className="text-center border-b bg-white dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6 border-r" colSpan={13}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
